import CheckboxElement from './checkbox-element';

export {
  CheckboxElement
};



// WEBPACK FOOTER //
// src/common/form-elements/checkbox-element-folder/index.js